import { makeStyles } from 'tss-react/mui';

const useStylesTableRowSummary: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  tableRowSummary: {
    cursor: 'default !important',
    borderTop: `2px solid ${theme.palette.info.main}`,
    borderBottom: `2px solid ${theme.palette.info.main}`,
    '& > td': {
      fontWeight: 500,
      borderRight: 'none !important',
      backgroundColor: theme.palette.background.default,
    },
  },
  tableRowSummaryBordered: {
    '& > td': {
      borderRight: 'inherit !important',
    },
  },
  tableRowSummaryNoHighlight: {
    background: 'inherit !important',
    '&:hover > td': {
      background: `${theme.palette.common.white} !important`,
    },
  },
  tableRowSummaryOffset: {
    padding: '16px 26px',
  },
  tableRowSummaryDarkBorders: {
    borderColor: theme.palette.info.main,
    '& > td': {
      borderRight: `solid 1px ${theme.palette.info.main} !important`,
    },
  },
}));

export default useStylesTableRowSummary;
